import { useQuery } from 'react-query';
import { ActivityCategory } from 'ui/types/activities';
import { PaginatedResponse } from 'ui/types/interfaces';
import { Organization } from 'ui/types/interfaces/organization';

import { useAppSelector } from '~/hooks/useAppSelector';
import { api } from '~/services/api';

export const useLoadOrganizationCauseOptions = () => {
  const { organizationSelectedId } = useAppSelector(({ auth }) => auth);

  const { data: organization, isLoading: isLoadingOrganization } =
    useQuery<Organization>({
      queryKey: `organization-${organizationSelectedId}`,
      queryFn: async () => {
        const response = await api.get(
          `organization/${organizationSelectedId}`,
        );

        return response.data;
      },
      cacheTime: 0,
      enabled: !!organizationSelectedId,
    });

  const organizationCauseOptions = organization?.causeOptions;

  const { data: causeOptionsData, isLoading: isLoadingCauses } = useQuery<
    PaginatedResponse<ActivityCategory[]>
  >({
    queryFn: async () => {
      const response = await api.get('activity-category', {
        params: {
          filter: JSON.stringify({
            relatedTo: ['causeOptions'],
            _id: { $in: organizationCauseOptions?.map((c) => c._id) || [] },
          }),
          limit: 200,
        },
      });

      return response.data;
    },
    cacheTime: 0,
    enabled: !!organization?._id,
  });

  const isLoading = isLoadingOrganization || isLoadingCauses;

  return { causeOptionsData, isLoading };
};
